import { render, staticRenderFns } from "./map-route-item.vue?vue&type=template&id=ca5bf9c8&scoped=true"
import script from "./map-route-item.vue?vue&type=script&lang=js"
export * from "./map-route-item.vue?vue&type=script&lang=js"
import style0 from "./map-route-item.vue?vue&type=style&index=0&id=ca5bf9c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca5bf9c8",
  null
  
)

export default component.exports